/* eslint-disable @typescript-eslint/no-unnecessary-condition */

export const probeWebGL = () => {
  const canvas = document.createElement('canvas')
  const gl =
    canvas.getContext &&
    ((canvas.getContext('webgl') as WebGLRenderingContext) ||
      (canvas.getContext('experimental-webgl') as WebGL2RenderingContext))
  const ext = gl && gl.getExtension('WEBGL_debug_renderer_info')

  if (gl && ext) {
    return {
      vendor: gl.getParameter(ext.UNMASKED_VENDOR_WEBGL),
      renderer: gl.getParameter(ext.UNMASKED_RENDERER_WEBGL),
    }
  }

  return {
    vendor: '',
    renderer: '',
  }
}
